import { takeEvery } from 'redux-saga/effects';

import { REQUEST } from 'services/api';
import {
  WIDGET_GLOBAL_VIEW_CHALLENGES,
  WIDGET_POINTS_DETAILS,
} from 'actions/widget.actions';
import {
  getWidgetGlobalViewChallengesSaga,
  getWidgetPointsDetailsSaga,
} from 'sagas/widget.saga';
import { SagaIterator } from '@redux-saga/types';

export function* getWidgetPointsDetailsSagaWatcher(): SagaIterator {
  yield takeEvery(WIDGET_POINTS_DETAILS[REQUEST], getWidgetPointsDetailsSaga);
}

export function* getWidgetGlobalViewChallengesSagaWatcher(): SagaIterator {
  yield takeEvery(
    WIDGET_GLOBAL_VIEW_CHALLENGES[REQUEST],
    getWidgetGlobalViewChallengesSaga,
  );
}
